import { useRef, useEffect } from "react";

import cn from "app/utils/classnames";

export interface DialogModalProps
  extends React.DialogHTMLAttributes<HTMLDialogElement> {
  children: React.ReactNode;
  className?: string;
  isOpen?: boolean;
}

export default function DialogModal({
  isOpen,
  children,
  className,
  ...props
}: DialogModalProps) {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    if (isOpen) {
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
    }
  }, [isOpen]);

  return (
    <dialog
      ref={dialogRef}
      className={cn(
        "mx-0 w-full max-w-none bg-transparent backdrop:bg-black/80 open:animate-fade-in-up sm:mx-auto",
        className,
      )}
      {...props}
    >
      {children}
    </dialog>
  );
}
